let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page013_game5/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 469,
      y: 138,
    },
  },
  activeArea: {
    width: 60,
    height: 60,
    fontSize: 39,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      animation: true,
      id: '1',
      textObj: {
        text: 'Kliknij prawym przyciskiem myszy na <i>Pulpicie.</i>',
      },
      audio: {
        src: 'games/page013_game5/audio/z6s13-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 644,
        y: 687,
      },
    },
    {
      id: '2',
      textObj: {
        text: 'Kliknij lewym przyciskiem w opcję <i>Nowy</i>.',
      },
      audio: {
        src: 'games/page013_game5/audio/z6s13-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 653,
        y: 877,
      },
    },
    {
      id: '3',
      textObj: {
        text: 'Kliknij w opcję <i>Folder</i>.',
      },
      audio: {
        src: 'games/page013_game5/audio/z6s13-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1003,
        y: 667,
      },
    },
    {
      id: '4',
      textObj: {
        text: 'Na <i>Pulpicie</i> pojawi się <i>Nowy folder</i>.',
      },
      audio: {
        src: 'games/page013_game5/audio/z6s13-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 905,
        y: 427,
      },
    },
    {
      id: '5',
      textObj: {
        text: 'Nadaj nazwę folderowi.',
      },
      audio: {
        src: 'games/page013_game5/audio/z6s13-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1165,
        y: 357,
      },
    },
  ],
};
export default elements;
